import { Stack } from '@mui/material'

import {
  ArtistItemOrdersConnectionFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { OrderedItemBox, OrderedItemBoxSkeleton } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  artistId: string
  items: Maybe<ArtistItemOrdersConnectionFragment>
  loading: boolean
  hasNextPage: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onFetchMore: () => Promise<void>
}

export const ConsoleItemOrdersTemplate: Template<State, Action> = ({
  state,
  onFetchMore,
}) => {
  const { t } = useTranslation('consoleItemOrders')
  const { routerNames, routerPages } = useRouter()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleItemOrders} />

      <ConsoleBaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleItems,
          title: t('title'),
        }}
      >
        <Stack sx={{ px: 5, pt: 5, pb: 6 }}>
          <ScrollFetcher
            nodes={state?.items?.edges.map(({ node }) => (
              <OrderedItemBox orderItem={node} key={node.id} />
            ))}
            loading={state.loading}
            hasNextPage={state.hasNextPage}
            onFetchMore={onFetchMore}
            emptyMessage={t('emptyData')}
            loadingComponent={
              <Stack spacing={3} sx={{ pb: 2 }}>
                {Array.from(Array(4).keys()).map(key => (
                  <OrderedItemBoxSkeleton key={key} />
                ))}
              </Stack>
            }
          />
        </Stack>
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
